import { cn } from '@/lib/cn';
import { TONE_DOT, type Tone } from '@/lib/status';

export interface TabItem {
  key: string;
  label: string;
  count?: number;
  tone?: Tone;
}

/** Segmented filter control used by Semáforo, Factores Externos, etc. */
export function FilterTabs({
  items,
  value,
  onChange,
  className,
}: {
  items: TabItem[];
  value: string;
  onChange: (key: string) => void;
  className?: string;
}) {
  return (
    <div className={cn('inline-flex flex-wrap items-center gap-1 rounded-xl border border-hairline bg-panel p-1', className)}>
      {items.map((item) => {
        const active = item.key === value;
        return (
          <button
            key={item.key}
            onClick={() => onChange(item.key)}
            className={cn(
              'inline-flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-medium transition-colors',
              active ? 'bg-primary text-white' : 'text-ink-muted hover:text-ink-strong hover:bg-hover',
            )}
          >
            {item.tone && <span className={cn('h-1.5 w-1.5 rounded-full', active ? 'bg-white' : TONE_DOT[item.tone])} />}
            {item.label}
            {item.count != null && (
              <span className={active ? 'text-white/80' : 'text-ink-faint'}>({item.count})</span>
            )}
          </button>
        );
      })}
    </div>
  );
}
